import { render } from "./RadioInput.vue?vue&type=template&id=aaff8c8e"
import script from "./RadioInput.vue?vue&type=script&lang=js"
export * from "./RadioInput.vue?vue&type=script&lang=js"

import "./RadioInput.vue?vue&type=style&index=0&id=aaff8c8e&lang=sass"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__